export default __webpack_public_path__ + "static/media/SWT1920.34I-40958_-24329_0.e0c71c96.jpg";